<template>
  <div id="dashboard">
    <PageHeader :title="title" :items="items"/>
    <roadmap v-if="false"/>
    <div>
      <b-row class="text-end mb-3">
        <b-col>
          <dashboard-filters
              v-if="marketplace"
              :marketplace="marketplace"
              @marketplace="handleMarketplace"
              @duration="handleDuration"
          />
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-col sm="12" md="12" xl="8" lg="8">
          <header-cards
              :statistics="statistics.headerCards"/>
          <email-statistics
              :date="duration"
              :statistics="statistics.messageStatisticsCard"/>
          <bottom-cards :statistics="statistics.bottomCards"/>
        </b-col>
        <b-col sm="12" md="12" xl="4" lg="4">
          <profile-card :user="user"/>
          <Comments
              :statistics="statistics.feedbacks"/>
        </b-col>
      </b-row>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <sales-chart
            :statistics="statistics.salesChart"
            :date="duration"
            :marketplace="marketplace">
        </sales-chart>
      </div>
    </div>
  </div>
</template>
<script>
import Comments from "./Components/Comment";
import DashboardService from "../../Services/Api/DashboardService";
import DashboardFilters from "./Components/DashboardFilters";
import SalesChart from "./Components/SalesChart";
import HeaderCards from "./Components/HeaderCards";
import EmailStatistics from "./Components/EmailStatistics";
import BottomCards from "./Components/BottomCards";
import Roadmap from "./Components/Roadmap";
import ProfileCard from "./Components/Profile";

export default {
  name: 'Dashboard',
  page() {
    return {
      title: this.$t('pages.dashboard.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {
    ProfileCard,
    Roadmap,
    BottomCards,
    HeaderCards,
    SalesChart,
    DashboardFilters,
    EmailStatistics,
    Comments,
  },
  data() {
    return {
      title: this.$t('pages.dashboard.title'),
      items: [
        {
          text: this.$t('pages.dashboard.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.dashboard.items.second'),
          active: true,
        },
      ],
      lastFeedback: [],
      infoCards: [],
      statistics: {
        headerCards: {
          loading: false,
          data: null
        },
        messageStatisticsCard: {
          loading: false,
          data: null
        },
        bottomCards: {
          loading: false,
          data: null
        },
        feedbacks: {
          loading: false,
          data: null
        },
        salesChart: {
          loading: false,
          data: null
        }
      },
      marketplace: null,
      duration: 30,
      user: null
    };
  },
  methods: {
    handleMarketplace(e) {
      this.marketplace = e
      this.getStatistics()
    },
    handleDuration(e) {
      this.duration = e
      this.getStatistics()
    },
    async getLastFeedback() {
      this.statistics.feedbacks.loading = true
      const {data: feedback} = await DashboardService.getLastFeedback(this.duration, this.marketplace)
      this.statistics.feedbacks.data = feedback.data
      this.statistics.feedbacks.loading = false
    },
    async getHeaderCards() {
      this.statistics.headerCards.loading = true
      const {data: statistics} = await DashboardService.getHeaderCards(this.duration, this.marketplace)
      this.statistics.headerCards.data = statistics.data
      this.statistics.headerCards.loading = false
    },
    async getBottomCards() {
      this.statistics.bottomCards.loading = true
      const {data: statistics} = await DashboardService.getBottomCards(this.duration, this.marketplace)
      this.statistics.bottomCards.data = statistics.data
      this.statistics.bottomCards.loading = false
    },
    async getSalesChart() {
      this.statistics.salesChart.id = null
      this.statistics.salesChart.loading = true
      const {data: statistics} = await DashboardService.getSalesChart(this.duration, this.marketplace)
      this.statistics.salesChart.data = statistics.data
      this.statistics.salesChart.id = performance.now()
      this.statistics.salesChart.loading = false

    },
    async getMessageStatisticsChart() {
      this.statistics.messageStatisticsCard.loading = true
      const {data: statistics} = await DashboardService.getMessageStatisticsChart(this.duration, this.marketplace)

      this.statistics.messageStatisticsCard.data = statistics.data
      this.statistics.messageStatisticsCard.id = performance.now()
      this.statistics.messageStatisticsCard.loading = false
    },
    getStatistics() {
      this.getLastFeedback()
      this.getHeaderCards()
      this.getMessageStatisticsChart()
      this.getBottomCards()
      this.getSalesChart()
    }
  },
  created() {
    this.$auth.load().then(() => {
      this.user = this.$auth.user()
      const marketplaces = this.user.marketplaces

      if (marketplaces.length > 0) {
        this.marketplace = marketplaces[0]
      }
    })
  }
};
</script>
<style>
.exit {
  right: 0;
  display: flex;
  position: absolute;
  top: 0;
  background: #2a2e33;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  justify-content: center;
}
</style>
